const ActiveSessions = () => import("Core/configuration/active_sessions/views/ActiveSessions");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/active_sessions",
            name: "settings_active_sessions",
            component: ActiveSessions,
            meta: {
                requiresAuth: true,
                title: "lang.active_sessions",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
